/* El Quarto — carrito (Cart AJAX API).
   - Agregar desde tarjetas y ficha: click delegado sobre [data-eq-add] con
     data-variant (id) y, opcionalmente, data-qty-from (selector del span de
     cantidad). El acuse visual lo hace eq-add.js; aca solo va la red.
   - El contador de la bolsa del header y el subrenglon de envio gratis se
     actualizan desde el evento `eq:cart` (detail = /cart.js). */

const S = window.EQ_SHOP || { routes: {}, cart: { count: 0, total: 0 }, envioGratisDesde: 60000 };

/* Compuerta del contador: mientras corre el acuse de un boton, la reconciliacion
   con el carrito real hace cola en vez de adelantarse al trazo. */
let enEspera = null;

async function getCart() {
  const r = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
  return r.json();
}

function emit(cart) {
  S.cart = { count: cart.item_count, total: cart.total_price };
  window.dispatchEvent(new CustomEvent('eq:cart', { detail: cart }));
}

async function add(variantId, quantity, portada, tipo, preventa) {
  const item = { id: Number(variantId), quantity: Math.max(1, Number(quantity) || 1) };
  // preventa: la linea va marcada con la llegada estimada (propiedad privada,
  // con _ no se muestra en el checkout) para poder separarla despues
  if (preventa != null) item.properties = { _preorder: preventa || 'sin fecha' };
  const r = await fetch(S.routes.cartAdd || '/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ items: [item] })
  });
  if (!r.ok) {
    let msg = 'No se pudo agregar';
    try { msg = (await r.json()).description || msg; } catch (e) {}
    const err = new Error(msg);
    err.status = r.status; // 422 = no hay mas stock para esa cantidad
    throw err;
  }
  let sumado = null;
  try { sumado = await r.json(); } catch (e) {}
  const cart = await getCart();
  emit(cart);
  avisarSumado(sumado, variantId, quantity, portada, tipo);
  return cart;
}

/* aviso de "sumado a la bolsa" (lo dibuja eq-bolsa.js): sale SOLO con el alta
   confirmada por el servidor, con los datos de la linea que devolvio add.js */
// el formato decide el objeto del aviso (vinilo / CD / cassette): se clasifica
// por contenido, no por texto exacto, asi "CDs", "CD", "Compact Disc", "Casete"
// o "Cassettes" caen donde corresponde
const formato = (t) => {
  const s = String(t || '').toLowerCase();
  if (s.indexOf('cass') !== -1 || s.indexOf('casete') !== -1) return 'Cassette';
  if (/(^|[^a-z])cds?([^a-z]|$)/.test(s) || s.indexOf('compact') !== -1) return 'CD';
  if (s.indexOf('vinil') !== -1 || s.indexOf('vinyl') !== -1 || /(^|[^a-z])lp([^a-z]|$)/.test(s)) return 'Vinilo';
  return String(t || '');
};
function avisarSumado(j, variantId, quantity, portada, tipoBoton) {
  const it = j && j.items && j.items.find((x) => String(x.variant_id) === String(variantId));
  if (!it) return;
  // el tipo que trae el boton (Liquid: product.type) manda; el de add.js, respaldo
  const tipo = String(tipoBoton || it.product_type || '');
  // la portada que la pagina ya tiene en cache (data-eq-img del boton); la de
  // la respuesta de add.js queda de respaldo
  let img = portada || '';
  if (!img) {
    const raw = (it.featured_image && it.featured_image.url) || it.image || '';
    if (raw) { try { img = new URL(raw, location.origin).toString(); } catch (e) { img = raw; } }
  }
  window.dispatchEvent(new CustomEvent('eq:bolsaSumar', { detail: {
    id: it.variant_id, t: it.product_title, a: it.vendor || '',
    fmt: formato(tipo), n: Math.max(1, Number(quantity) || 1), img
  } }));
}

async function change(line, quantity) {
  const r = await fetch(S.routes.cartChange || '/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ line: Number(line), quantity: Number(quantity) })
  });
  const cart = await r.json();
  emit(cart);
  return cart;
}

document.addEventListener('click', async (e) => {
  const b = e.target.closest && e.target.closest('[data-eq-add]');
  if (!b) return;
  e.preventDefault();
  e.stopPropagation();
  if (b.dataset.eqBusyNet) return;
  const variant = b.dataset.variant;
  if (!variant) return;
  let qty = 1;
  if (b.dataset.qtyFrom) {
    const q = document.querySelector(b.dataset.qtyFrom);
    if (q) qty = Number(q.textContent || q.value) || 1;
  }
  const label = b.querySelector('[data-eq-label]');
  b.dataset.eqBusyNet = '1';
  // El acuse responde al GESTO, no a la red: el trazo arranca en el mismo click
  // y la peticion corre en paralelo; solo si falla se corrige (rotulo en bordo,
  // contador de vuelta). Pero la bolsa NO se toca mientras el trazo da la
  // vuelta: el numero sube cuando el aro CIERRA, junto con "Sumado", asi los dos
  // son un solo hecho. Si la respuesta real llega antes, hace cola y se pinta
  // en ese mismo momento.
  const antes = { count: S.cart.count, total: S.cart.total, texto: label ? label.textContent : '' };
  const cola = [];
  enEspera = cola;
  let fallo = false;
  const abrir = () => {
    if (enEspera !== cola) return; // otro click tomo la posta
    enEspera = null;
    if (fallo) { pintarBolsa(antes.count, antes.total); return; }
    const real = cola.pop();
    if (real) real();
    else pintarBolsa(antes.count + qty, antes.total);
  };
  const corrio = window.eqTrazoAgregar && label
    ? window.eqTrazoAgregar(b, label, b.dataset.hecho || 'Sumado', abrir)
    : false;
  if (!corrio) abrir();
  try {
    await add(variant, qty, b.dataset.eqImg || '', b.dataset.eqFmt || '', b.dataset.eqPre); // emite eq:cart con el carrito real (reconcilia)
  } catch (err) {
    fallo = true;
    if (enEspera !== cola) pintarBolsa(antes.count, antes.total);
    if (label) {
      // se corta el acuse (si no, escribia "Sumado" encima del error)
      if (window.eqTrazoAbortar) window.eqTrazoAbortar(b);
      else { const svg = b.querySelector('svg[data-eq-aroadd]'); if (svg) svg.remove(); label.getAnimations().forEach((a) => a.cancel()); }
      // rotulo corto y propio: el de Shopify es largo (y a veces en ingles)
      label.textContent = err.status === 422 ? 'Sin más stock' : 'No se pudo agregar';
      // el error sale del hover: bordo sobre el negro del hover no se leia
      b.style.color = 'var(--eq-bordo)';
      b.style.borderColor = 'var(--eq-bordo)';
      b.style.background = 'var(--eq-paper)';
      setTimeout(() => {
        label.textContent = antes.texto;
        b.style.color = ''; b.style.borderColor = ''; b.style.background = '';
        delete b.dataset.eqBusy;
      }, 2200);
    }
  } finally {
    delete b.dataset.eqBusyNet;
  }
});

/* contador de la bolsa: con cero no se muestra nada, de 10 en adelante "9+" */
function pintarBolsa(count, total) {
  document.querySelectorAll('[data-eq-cart-count]').forEach((n) => {
    n.textContent = count > 9 ? '9+' : String(count);
    n.hidden = count === 0;
  });
  // el nombre accesible dice cuantos hay (el numerito solo se ve)
  document.querySelectorAll('[data-eq-bolsa-btn]').forEach((b) => {
    b.setAttribute('aria-label', 'Bolsa, ' + (count === 0 ? 'vacía' : count === 1 ? '1 disco' : count + ' discos'));
  });
  const umbral = Number(S.envioGratisDesde) * 100;
  document.querySelectorAll('[data-eq-envio-sub]').forEach((el) => {
    const t = el.querySelector('[data-eq-envio-txt]');
    if (!t) return;
    // solo el texto y si hay algo en la bolsa: cuando se muestra lo decide el
    // aviso de "sumado" (eq-bolsa.js), y flota fuera del flujo (no mueve nada)
    el.dataset.eqOn = count === 0 ? '0' : '1';
    if (count === 0) return;
    if (total >= umbral) t.textContent = el.dataset.msgOk || 'Tu pedido ya tiene envío gratis';
    else t.textContent = (el.dataset.msgFaltan || 'Te faltan $ {monto} para el envío gratis').replace(/\{monto\}|\[monto\]/g, window.EQ ? window.EQ.money(umbral - total) : String(Math.round((umbral - total) / 100)));
  });
}
window.addEventListener('eq:cart', (e) => {
  // el cajon tambien emite eq:cart: el conteo de referencia se mantiene al dia
  S.cart = { count: e.detail.item_count, total: e.detail.total_price };
  const pintar = () => pintarBolsa(e.detail.item_count, e.detail.total_price);
  if (enEspera) enEspera.push(pintar);
  else pintar();
});
pintarBolsa(S.cart.count, S.cart.total);

window.EQCart = { getCart, add, change };
export { getCart, add, change };
